var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home"},[_c('NavBar',{attrs:{"headtitle":'选择大区',"typeFn":2}}),_c('div',{staticClass:"serverBox"},[_c('div',{staticClass:"serverList"},[_c('ul',_vm._l((_vm.serverList),function(item){return _c('li',{key:item.serverid,on:{"click":function($event){_vm.$router.push({
              path: '/tradingCenter',
              query: { serverData: JSON.stringify(item), obj: _vm.obj },
            })}}},[_vm._v("\n          "+_vm._s(item.server_name)+"\n        ")])}),0)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }